import { HttpClient, HttpEvent, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { ProviderUpdateDocumentModel } from 'src/app/models/archive/provider-update-document.model';
import { ProviderModel } from 'src/app/models/archive/provider.model';
import { ItemFilterModel } from 'src/app/models/filters/item-filter.model';
import { ProviderImportModel } from 'src/app/models/imports/provider-import.model';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProviderService {
  constructor(private _httpClient: HttpClient) { }

  createProvider(providerContractModel: ProviderModel): Observable<ProviderModel> {
    return this._httpClient.post<ProviderModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.provider.CreateProvider}`,
      providerContractModel);
  }

  deleteProvider(providerId: number): Observable<ProviderModel> {
    return this._httpClient.delete<ProviderModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.provider.DeleteProvider}/${providerId}`);
  }

  downloadGuideImport(): Observable<HttpEvent<Blob>> {
    return this._httpClient.request(new HttpRequest('GET', `${environment.apiCervinoBackend}${enpointCervinoWeb.provider.DownloadGuideImport}`,
      null, { reportProgress: true, responseType: 'blob' }));
  }

  exportGeneralConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.provider.ExportGeneralConsultation}`, filters, {
      params, responseType: 'blob',
    });
  }

  exportImportErrors(alerts: PreInvoicingAlertModel[]): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.provider.ExportImportErrors}`, alerts,
      {
        responseType: 'blob'
      }
    );
  }

  getAllProvidersForSelect(): Observable<any[]> {
    return this._httpClient.get<any[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.provider.GetAllProvidersForSelect}`);
  }

  getAllProvidersTransportForSelect(): Observable<any[]> {
    return this._httpClient.get<any[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.provider.GetAllProvidersTransportForSelectAsync}`);
  }

  getAllProvidersWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.provider.GetAllProvidersWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.provider.GetColumnsForGeneralConsultationAsync}`);
  }

  getDigitVerification(document: string): Observable<number> {
    const itemFilterResponse = new ItemFilterModel("document", null, null, "");
    itemFilterResponse.wildcard = document;
    return this._httpClient.post<number>(`${environment.apiCervinoBackend}${enpointCervinoWeb.provider.GetDigitVerification}`, itemFilterResponse);
  }

  getProviderByDocumentAsync(document: string): Observable<ProviderModel> {
    const itemFilterResponse = new ItemFilterModel("document", null, null, "");
    itemFilterResponse.wildcard = document;
    return this._httpClient.post<ProviderModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.provider.GetProviderByDocumentAsync}`, itemFilterResponse)
  }

  getProviderById(providerId: number): Observable<ProviderModel> {
    return this._httpClient.get<ProviderModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.provider.GetProviderById}/${providerId}`);
  }

  getProviderByIdForSelect(providerId: number): Observable<any> {
    return this._httpClient.get<any>(`${environment.apiCervinoBackend}${enpointCervinoWeb.provider.GetProviderByIdForSelect}/${providerId}`
    );
  }

  importProviders(providerImports: Array<ProviderImportModel>): Observable<LoadPreInvoicingModel> {
    return this._httpClient.post<LoadPreInvoicingModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.provider.ImportProvider}`,
      providerImports);
  }

  setActiveProvider(providerId: number): Observable<ProviderModel> {
    return this._httpClient.put<ProviderModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.provider.SetActiveProvider}/${providerId}`,
      null);
  }

  updateProvider(providerContractModel: ProviderModel): Observable<ProviderModel> {
    return this._httpClient.put<ProviderModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.provider.UpdateProvider}`,
      providerContractModel);
  }

  updateProviderDocument(providerContractModel: ProviderUpdateDocumentModel): Observable<ProviderModel> {
    return this._httpClient.put<ProviderModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.provider.UpdateProviderDocument}`,
      providerContractModel);
  }

}
